import { useTranslation } from 'react-i18next';
import jaPilot from 'assets/images/onboard/ja_pilot.jpg';
import jaCabinCrew from 'assets/images/onboard/ja_cabin_crew.jpg';
import jaDelivery from 'assets/images/onboard/ja_delivery.jpg';
import jaSenior from 'assets/images/onboard/ja_senior.jpg';
import enPilot from 'assets/images/onboard/en_pilot.jpg';
import enCabinCrew from 'assets/images/onboard/en_cabin_crew.jpg';
import enSunglasses from 'assets/images/onboard/en_sunglasses.jpg';
import enGreenShirt from 'assets/images/onboard/en_green_shirt.jpg';
import safetyPanel from 'assets/images/onboard/safety_panel.jpg';

// 和田様の案（11/3）。ログインの右側は人物4人を2×2で、日本語と英語で人物を替える。
// パスワードを忘れた・再設定・新しいパスワードの画面は「Yometel／ご安全に／RovQuest」。
const PEOPLE: Record<string, string[]> = {
  jp: [jaPilot, jaCabinCrew, jaDelivery, jaSenior],
  en: [enPilot, enCabinCrew, enSunglasses, enGreenShirt],
};

type MainOnboardProps = {
  variant?: 'people' | 'safety';
};

const MainOnboard = ({ variant = 'people' }: MainOnboardProps) => {
  const { i18n } = useTranslation();

  if (variant === 'safety') {
    return (
      <div className="hidden md:flex flex-1 items-center justify-center bg-white">
        <img src={safetyPanel} alt="" className="w-full max-w-md h-auto" />
      </div>
    );
  }

  const people = PEOPLE[i18n.language === 'en' ? 'en' : 'jp'];
  return (
    <div className="hidden md:flex flex-1 items-center justify-center bg-white">
      <div className="grid grid-cols-2 gap-8 w-full max-w-lg px-8">
        {people.map((src) => (
          <img
            key={src}
            src={src}
            alt=""
            className="w-full aspect-[2/3] object-cover rounded-lg"
          />
        ))}
      </div>
    </div>
  );
};

export default MainOnboard;
